import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import { logout as logoutAction } from 'Reducer/Autenticacao';
import { useLogoutMutation } from 'Service';
import { useAppDispatch, useAppSelector } from 'Store';

const MenuSuperior = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);
  const token = useAppSelector((estado) => estado.autenticacao.token);
  const dispatch = useAppDispatch();
  const [logout] = useLogoutMutation();

  const sair = async (): Promise<void> => {
    try {
      await logout().unwrap();

      dispatch(logoutAction());

      navegacao('/login');
    } catch (erro) {
      toast({
        titulo: 'Erro ao fazer logout',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm sticky-top">
      <div className="container-fluid">
        <span className="navbar-brand ms-0 ms-sm-2 ps-1">ERP</span>
        <ul className="navbar-nav ms-auto d-inline-block">
          <li className="nav-item d-inline-block dropdown">
            <a
              className="nav-link active px-3"
              href="#"
              data-bs-toggle="dropdown"
            >
              <Icone nome="grid-3x3-gap-fill" />
            </a>
            <ul
              className="dropdown-menu text-small border-0 shadow position-absolute mr-2"
              style={{ left: '-100px', minWidth: '15rem' }}
            >
              <li className="d-inline-block">
                <button
                  type="button"
                  className="dropdown-item text-center"
                  onClick={() =>
                    window.open(`https://erp.tudogas.com.br/login?token=${token}`)
                  }
                >
                  <Imagem
                    src="icone-erp.png"
                    className="hf-50 d-block"
                  />
                  ERP
                </button>
              </li>
              <li className="d-inline-block">
                <button
                  type="button"
                  className="dropdown-item text-center"
                  onClick={() =>
                    window.open(`https://os.tudogas.com.br/login?token=${token}`)
                  }
                >
                  <Imagem
                    src="icone-os.png"
                    className="hf-50 d-block"
                  />
                  OS
                </button>
              </li>
            </ul>
          </li>
          {['admin', 'super'].includes(usuario?.permissao || '') && (
            <li className="nav-item d-inline-block">
              <Link className="nav-link active pe-4" to="/alertas">
                <Icone nome="exclamation-triangle-fill" />
              </Link>
            </li>
          )}
          <li className="nav-item d-inline-block dropdown">
            <a
              className="nav-link active p-0"
              aria-current="page"
              href="#"
              data-bs-toggle="dropdown"
            >
              <span className="pt-2 d-inline-block">{usuario?.nome.split(' ')[0]}</span>
              <Imagem
                src={usuario?.imagem}
                width="36"
                height="36"
                className="rounded-circle ms-3 mt-n1"
              />
            </a>
            <ul
              className="dropdown-menu text-small border-0 shadow position-absolute mr-2"
              style={{ left: '-10px' }}
            >
              <li>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => navegacao('/alterar-senha')}
                >
                  Alterar senha
                </button>
              </li>
              <li>
                <button type="button" className="dropdown-item" onClick={sair}>
                  Sair
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default MenuSuperior;
